import { render, staticRenderFns } from "./ReviewTemplate.vue?vue&type=template&id=4ef49011&scoped=true&"
import script from "./ReviewTemplate.vue?vue&type=script&lang=js&"
export * from "./ReviewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTemplate.vue?vue&type=style&index=0&id=4ef49011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef49011",
  null
  
)

export default component.exports